module.exports = __webpack_public_path__ + "img/공제어감각.59cf39f9.svg";